module.exports = __webpack_public_path__ + "img/ssu_logo.32f83e4f.png";